import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ICreateExtractsAction } from '../../../../ts/ServerApi/types/actionNames';
import { createExtractsMethod } from '../../../actions/spaces/RunCreateExtractsAction';
import { IEntityAction } from './IEntityAction';

export const CreateExtractsAction: IEntityAction<IContentInfo, ICreateExtractsAction> = {
  name: 'create_extracts',
  translateName: Messages.createExtracts_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return FeatureFlags.extractMoveToTheWebEnabled;
  },
  isClickable: (availableActions: ICreateExtractsAction, targetItems: IContentInfo[]) => {
    return targetItems.length > 1 || !!(availableActions && availableActions.createExtracts);
  },
  createReduxAction: (targetItems: IContentInfo[]) => createExtractsMethod(targetItems)
};
